type Id = string;

const id: Id = "";

export type { Id };

export { id };
